<div class="d-grid gap-3" style="grid-template-columns: 350px 1fr" *ngIf="viewType !== 'table'">
  <app-automation-wizard-left
    [type]="type"
    (typeChange)="typeChange.emit($event)"
    image="/assets/images/automation-wizards/incident.webp"
  >
    <ng-container i18n
      >An incident represents an unexpected issue or situation requiring attention, such as maintenance or guest
      concerns. It includes actions like notifying the property manager, setting follow-up reminders, and updating the
      status as resolved or escalated. Managing incidents ensures timely problem resolution and
      communication.</ng-container
    >
  </app-automation-wizard-left>
  <div class="card shadow">
    <div class="card-header flex-column align-items-start p-3 bg-default2">
      <h6 i18n>What would you like to do when an incident is</h6>
      <div class="btn-group">
        <button
          type="button"
          (click)="onSelectEvent(events.IncidentCreated)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.IncidentCreated ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Created
        </button>
        <button
          type="button"
          (click)="onSelectEvent(events.IncidentCritical)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.IncidentCritical ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Critical
        </button>
        <button
          type="button"
          (click)="onSelectEvent(events.IncidentResolved)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.IncidentResolved ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Resolved
        </button>
        <button
          type="button"
          (click)="onSelectEvent(events.IncidentOnHold)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.IncidentOnHold ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          On Hold
        </button>
      </div>
    </div>
    <div class="card-body d-flex flex-column gap-3">
      <ng-container [ngSwitch]="selectedEvent">
        <ng-template *ngSwitchCase="events.IncidentCreated" [ngTemplateOutlet]="createdEvent"></ng-template>
        <ng-template *ngSwitchCase="events.IncidentCritical" [ngTemplateOutlet]="criticalEvent"></ng-template>
        <ng-template *ngSwitchCase="events.IncidentResolved" [ngTemplateOutlet]="resolvedEvent"></ng-template>
        <ng-template *ngSwitchCase="events.IncidentOnHold" [ngTemplateOutlet]="holdEvent"></ng-template>
      </ng-container>
      <div class="flex-fill"></div>
      <app-automation-channel-rental-select
        [form]="form"
        [allowsChannel]="false"
      ></app-automation-channel-rental-select>
    </div>
  </div>
</div>

<div *ngIf="viewType === 'table'" class="d-flex flex-column gap-4 automation-table">
  <div class="table-view-header text-muted text-semi-bold">
    <div class="text-uppercase text-muted mb-0" i18n>What would you like to do when</div>
    <div i18n>Created Date • Time</div>
    <div i18n>Last Triggered Date • Time</div>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Incident is Created</h6>
    <ng-template [ngTemplateOutlet]="createdEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Incident is Critical</h6>
    <ng-template [ngTemplateOutlet]="criticalEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Incident is Resolved</h6>
    <ng-template [ngTemplateOutlet]="resolvedEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Incident is On Hold</h6>
    <ng-template [ngTemplateOutlet]="holdEvent"></ng-template>
  </div>
</div>

<ng-template #createdEvent>
  <app-do-action-automation
    [event]="events.IncidentCreated"
    [type]="automationTypes.Rental"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.RentalMarkNotReadyHandler"
    i18n-label
    i18n-name
    label="Set the rental status to Not Ready"
    name="Set the rental status to Not Ready when incident created"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>

  <app-notify-handler-automation
    [event]="events.IncidentCreated"
    [handler]="eventHandlers.IncidentNotifyGuestHandler"
    [type]="type"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify the guest"
    name="Notify the guest of the incident created"
    [messageSubject]="guestNotificationMessages[events.IncidentCreated].subject"
    [messageBody]="guestNotificationMessages[events.IncidentCreated].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
    [filterByCategories]="true"
    [categories]="categories$ | async"
  >
  </app-notify-handler-automation>

  <app-notify-users-automation
    [event]="events.IncidentCreated"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify the user(s)"
    name="Notify the user(s) of incident created"
    [messageSubject]="userNotificationMessages[events.IncidentCreated].subject"
    [messageBody]="userNotificationMessages[events.IncidentCreated].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>

  <app-autopilot-automations-group
    [handler]="eventHandlers.IncidentCreateTaskHandler"
    [event]="events.IncidentCreated"
    [type]="automationTypes.Task"
    [viewType]="viewType"
    [initData]="{ data: taskForNewIncident }"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
    i18n-addLabel
    i18n-idPrefix
    i18n-label
    i18n-name
    addLabel="Add Task Automation"
    idPrefix="autopilot-task"
    label="Create a task and assign to a user"
    name="Create a task for new incident"
  >
    <ng-template
      autopilotAutomationGroupItem
      let-item="item"
      let-name="name"
      let-label="label"
      let-event="event"
      let-handler="handler"
    >
      <app-new-task-automation
        [handler]="handler"
        [event]="event"
        [viewType]="viewType"
        [eventSourceType]="type"
        [hideDateFields]="true"
        [automation]="item"
        [label]="label"
        [name]="name"
        [task]="taskForNewIncident"
        [filterByCategories]="true"
        [categories]="categories$ | async"
        [rentals]="form.get('rentals').value"
        [channels]="form.get('channels').value"
        [deletable]="true"
      ></app-new-task-automation>
    </ng-template>
  </app-autopilot-automations-group>
</ng-template>

<ng-template #criticalEvent>
  <app-notify-users-automation
    [event]="events.IncidentCritical"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify the user(s)"
    name="Notify the user(s) of critical incident"
    [messageSubject]="userNotificationMessages[events.IncidentCritical].subject"
    [messageBody]="userNotificationMessages[events.IncidentCritical].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>
</ng-template>

<ng-template #resolvedEvent>
  <app-do-action-automation
    [event]="events.IncidentResolved"
    [type]="automationTypes.Rental"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.RentalMarkReadyHandler"
    i18n-label
    i18n-name
    label="Set the rental status to Ready"
    name="Set the rental status to Ready when incident resolved"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>

  <app-notify-handler-automation
    [event]="events.IncidentResolved"
    [handler]="eventHandlers.IncidentNotifyGuestHandler"
    [type]="type"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify the guest"
    name="Notify the guest of the incident resolved"
    [messageSubject]="guestNotificationMessages[events.IncidentResolved].subject"
    [messageBody]="guestNotificationMessages[events.IncidentResolved].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
    [filterByCategories]="true"
    [categories]="categories$ | async"
  >
  </app-notify-handler-automation>

  <app-notify-users-automation
    [event]="events.IncidentResolved"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify the user(s)"
    name="Notify the user(s) of incident resolved"
    [messageSubject]="userNotificationMessages[events.IncidentResolved].subject"
    [messageBody]="userNotificationMessages[events.IncidentResolved].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>
</ng-template>

<ng-template #holdEvent>
  <app-notify-users-automation
    [event]="events.IncidentOnHold"
    [viewType]="viewType"
    [eventSourceType]="type"
    [delayed]="true"
    i18n-idSuffix
    i18n-label
    i18n-name
    idSuffix="reminder"
    label="Set follow-up reminder for X hours."
    name="Set follow-up reminder for X hours for incident on hold"
    [messageSubject]="userNotificationMessages[events.IncidentOnHold].subject"
    [messageBody]="userNotificationMessages[events.IncidentOnHold].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>
  <app-notify-users-automation
    [event]="events.IncidentOnHold"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify the user(s)"
    name="Notify the user(s) of incident on hold"
    [messageSubject]="userNotificationMessages[events.IncidentOnHold].subject"
    [messageBody]="userNotificationMessages[events.IncidentOnHold].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>
</ng-template>
